<template>
  <modal
    v-if="modelValue"
    ref="videoModal"
    class="modal--large"
    size="large"
    :title="false"
    :show-footer="false"
    :show="modelValue"
    @modal:closed="closeVideoModal">
    <div>
      <div
        style="max-width: calc(16 / 9 * 0.6 * 100vh); margin-inline: auto !important"
        class="video-container margin-l border-s border-radius-s box-shadow-4">
        <ratio-container class="border-radius-s" :ratio="16 / 9">
          <iframe
            class="border-radius-s"
            loading="lazy"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/hfJ3KsC7Z3g?autoplay=1"
            title="YouTube video player"
            allow="accelerometer; clipboard-write; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </ratio-container>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "VideoModal",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    closeVideoModal() {
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-container {
  flex: 0 0 360px;
  margin-top: calc(12 * var(--base-font-size));
  max-width: calc(16 / 9 * 0.6 * 100vh);
  margin-inline: auto !important;
  background-color: var(--c-gray-1-alt);
  border-color: var(--c-light-gray-2);

  @media (max-width: 1024px) {
    width: 300px;
    flex: auto;
  }
}
</style>
